import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import "./HeaderFooterLayout.css";
import SocialLinks from "./SocialLinks";


export default function HeaderFooterLayout({ children }) {
  const { session, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  // Determine the title based on the current path
  let title = "POD RECS";
  if (location.pathname === "/saved") {
    title = "SAVED RECS";
  } else if (id) {
    title = id;
    if (title === "imperfects") {
      title = "The Imperfects"
    } else if (title === "styleish") {
      title = "Style-ish"
    } else if (title === "workinghard") {
      title = "Working Hard"
    } else if (title === "mamamiaoutloud") {
      title = "Mamamia Out Loud"
    } else if (title === "shameless") {
      title = "Shameless"
    } else if (title === "wedonthavetimeforthis") {
      title = "We Don't Have Time For This"
    } else if (title === "lifeuncut") {
      title = "Life Uncut"
    }
  } else if (location.pathname === "/login") {
    title = ""
  } else if (location.pathname === "/browse") {
    title = "PODCASTS"
  } 

  const handleLogout = () => {
    window.dispatchEvent(new CustomEvent("showVisitModal", {
      detail: {
        title: "Are you sure?",
        message: "Stay logged in to view your faves!",
        buttons: [
          {
            label: "Keep me logged in",
            className: "login-button",
            onClick: () => {
              window.dispatchEvent(new CustomEvent("closeVisitModal"));
            }
          },
          {
            label: "LOG OUT",
            className: "link-button",
            onClick: () => {
              window.dispatchEvent(new CustomEvent("closeVisitModal")); // close it immediately
              signOut();
              navigate("/");
            }
          }
        ]
      }
    }));
  }

  return (
    <div className="page-wrapper">
        <header className="global-header">
          <div className="header-buttons">
            <div className="header-left">
            {!(location.pathname === "/browse" && session) && location.pathname !== "/" && (
            <button
              className="back-button"
              style={{ marginLeft: "32px" }}
              onClick={() => {
                if (location.pathname === "/saved" || location.pathname === "/login") {
                  navigate(-1);
                } else if (location.pathname === "/browse") {
                  navigate("/");
                } else {
                  navigate("/browse");
                }
              }}
            >
              ←
            </button>
          )}

          </div>

            <div className="header-right">
            {location.pathname !== "/login" && (
              <div className="header-right">
                {!session ? (
                  <button
                    className="login-button"
                    onClick={() => navigate(`/login?redirect=${encodeURIComponent(window.location.pathname)}`)}
                  >
                    Log in
                  </button>
                ) : location.pathname === "/saved" ? (
                  <button
                    className="login-button logout-button"
                    onClick={() => {
                      handleLogout()
                    }}
                  >
                    Log out
                  </button>
                ) : (
                  <button
                    className="login-button saved-recs-button"
                    onClick={() => navigate("/saved")}
                  >
                    Saved Recs
                  </button>
                )}
              </div>
            )}
            </div>
          </div>
          {title && (
            <>
              <div className="header-center">
                <h1 className="header-title">{title}</h1>
              </div>
              {title === "PODCASTS" && (
                <div className="header-subcenter">
                  <p className="header-subtitle">
                    Pick a pod, see what they’re loving 🔥
                  </p>
                </div>
              )}
              {title === "POD RECS" && (
                <div className="header-subcenter">
                  <p className="header-subtitle">
                    Browse recs from your fave pods 🎧
                  </p>
                  {!session && (
                    <p className="header-subtitle" style={{ marginTop: "4px" }}>
                      Create an account to save your faves 💛
                    </p>
                  )}
                </div>
              )}
            </>
          )}
          <SocialLinks id={id} />
        </header>
      <main>{children}</main>

      <footer className="global-footer">
        <p className="instagram-link">
          <a
            href="https://www.instagram.com/pod_recs/?igsh=MWlxZ3h0NnBrZTMycg%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
          <img
            src="/instagram_icon.png"
            alt="Instagram"
            className="instagram-icon"
          />
            <span>Follow us on Instagram</span>
          </a>
        </p>
        <p>Contact: steph@pod-recs.com</p>
      </footer>
    </div>
  );
}
